import validate from './plugins/validate';

export default function(Vue) {
  Vue.use(validate);
}
